var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"by-card2"},[(_vm.header)?_c('div',{staticClass:"by-card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"by-card-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4598559e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","audio":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/ByCard.vue
// module id = null
// module chunks = 